import { Debug, Utils, ReduxSagaRequest, Request } from "@hlibs/index";
import Language from "@app/language";

export const Excel = async (payload, callback, reduxModule) => {
  const stateKey = "Excel";

  if (Utils.checkNullOrEmpty(payload, payload.from, payload.to))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );

  try {
    const response = await Request.get("/ad/stats/excel", {
      from: payload.from,
      to: payload.to,
      url_response: "Y",
    });
    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.set(data, "ad");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Stats = async (payload, callback, reduxModule) => {
  const stateKey = "Stats";

  if (
    Utils.checkNullOrEmpty(payload) ||
    (Utils.checkNullOrEmpty(payload.from) && Utils.checkNullOrEmpty(payload.to)) // to 랑 from 둘중에 하나는 있어야함
  )
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );

  try {
    const response = await Request.get("/ad/stats", {
      from: payload.from,
      to: payload.to,
      // from: "2022-04-01",
      // to: "2022-04-10",
    });
    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const List = async (callback, reduxModule) => {
  const stateKey = "List";

  try {
    const response = await Request.get("/ad/list");
    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.set(data, "ad");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Info = async (payload, callback, reduxModule) => {
  const stateKey = "Info";

  if (Utils.checkNullOrEmpty(payload, payload.ad_id))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.get("/ad/info", {
      ad_id: payload.ad_id,
    });
    const { data } = response;

    if (callback) callback(data, response);

    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (Utils.checkKeyExists(data, ["id"])) {
      reduxModule.set(data, "ad");

      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Add = async (payload, callback, reduxModule) => {
  const stateKey = "Add";
  if (Utils.checkNullOrEmpty(payload))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.post("/ad/info", {
      advertiser_code: payload.advertiser_code,
      data: {
        ad_type: payload.ad_type,
        ad_filter: payload.ad_filter,
        ad_user: payload.ad_user,
        title: payload.title,
        banners: payload.banners,
        view_date_start: payload.view_date_start,
        view_date_end: payload.view_date_end,
        cpm_limit: payload.cpm_limit,
        order_num: payload.order_num,
        extra: payload.extra,
      },
    });
    const { data } = response;
    if (callback) callback(data, response);
    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Update = async (payload, callback, reduxModule) => {
  const stateKey = "Update";
  if (Utils.checkNullOrEmpty(payload))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.patch("/ad/info", {
      group_id: payload.ad_id,
      data: {
        advertiser_code: payload.advertiser_code,
        ad_type: payload.ad_type,
        ad_filter: payload.ad_filter,
        ad_user: payload.ad_user,
        title: payload.title,
        banners: payload.banners,
        view_date_start: payload.view_date_start,
        view_date_end: payload.view_date_end,
        cpm_limit: payload.cpm_limit,
        order_num: payload.order_num,
        extra: payload.extra,
      },
    });
    const { data } = response;
    if (callback) callback(data, response);
    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Update2 = async (payload, callback, reduxModule) => {
  const stateKey = "Update2";
  if (Utils.checkNullOrEmpty(payload))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.patch("/ad/info", {
      ad_id: payload.ad_id,
      data: {
        img_url: payload.img_url,
        link_url: payload.link_url,
        link_url_i: payload.link_url_i,
      },
    });
    const { data } = response;
    if (callback) callback(data, response);
    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};

export const Delete = async (payload, callback, reduxModule) => {
  const stateKey = "Delete";
  if (Utils.checkNullOrEmpty(payload, payload.ad_id))
    return ReduxSagaRequest.makeResult.failureWithMessage(
      Language.Server.err3,
      stateKey
    );
  try {
    const response = await Request.delete("/ad/info", {
      ad_id: payload.ad_id,
    });
    const { data } = response;
    if (callback) callback(data, response);
    if (data?.error) {
      return ReduxSagaRequest.makeResult.failure(data, stateKey);
    } else if (data) {
      return ReduxSagaRequest.makeResult.success(data, stateKey);
    }
  } catch (e) {
    if (process.env.MODE !== "RELEASE") Debug.exception(e);
  }

  return ReduxSagaRequest.makeResult.failureWithMessage(
    Language.Server.err1,
    stateKey
  );
};
